{
    "SymbolLabel": "Symbool:",
    "SymbolNote": "(Hiermee worden wijzigingen automatisch toegepast op velden hieronder)",
    "PatternLabel": "Patroon:",
    "GroupingseparatorLabel": "Groepering scheidingsteken:",
    "GroupingseparatorOptionCommaDesc": "(Komma)",
    "GroupingseparatorOptionSpaceDesc": "(Ruimte)",
    "GroupingseparatorOptionFullstopDesc": "(Punt)",
    "DecimalseparatorLabel": "Decimaalscheidingsteken:",
    "DecimalseparatorOptionFullstopDesc": "(Punt)",
    "DecimalseparatorOptionColonDesc": "(Dikke darm)",
    "DecimalseparatorOptionCommaDesc": "(Komma)",
    "PreviewLabel": "Preview",
    "CurrencyDisplayFormat_SectionHeader": "Valutaweergave-indeling",
    "NAME": "CurrencyDisplayFormat"
}